import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/messaging'
import 'firebase/storage'

export type GoogleUserProfile = { id: string; email: string; name: string }

export const initialize = () => {
  if (firebase.apps.length > 0) return
  const firebaseConfig = {
    apiKey: 'AIzaSyAuqmZ6ZsmgdKKSWt5sFPiKlHQgVapZbTk',
    authDomain: 'gadjet-v2.firebaseapp.com',
    projectId: 'gadjet-v2',
    storageBucket: 'gadjet-v2.appspot.com',
    messagingSenderId: '780095536764',
    appId: '1:780095536764:web:d7005bbb92129ee687d3f9',
    measurementId: 'G-C1JGSF9FE8',
  }
  firebase.initializeApp(firebaseConfig)
}

initialize()

export const storage = firebase.storage()

export const messaging = firebase.messaging.isSupported() ? firebase.messaging() : undefined

export const auth = firebase.auth()

export const googleLogin = async (useRedirect = false) => {
  try {
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.setCustomParameters({
      prompt: 'select_account',
    })

    if (useRedirect) {
      await auth.signInWithRedirect(provider)
      return null as any
    }

    return await auth.signInWithPopup(provider)
  } catch (error: any) {
    const errorCode = error?.code
    let userFriendlyMessage = 'Google login failed'

    switch (errorCode) {
      case 'auth/popup-closed-by-user':
        userFriendlyMessage = 'Google sign-in popup was closed before completing login'
        break
      case 'auth/popup-blocked':
        userFriendlyMessage = 'Popup was blocked by browser. Please allow popups for this site'
        break
      case 'auth/cancelled-popup-request':
        userFriendlyMessage = 'Only one popup request is allowed at a time'
        break
      case 'auth/unauthorized-domain':
        userFriendlyMessage = 'This domain is not authorized for Google sign-in. Please contact support.'
        break
      case 'auth/operation-not-allowed':
        userFriendlyMessage = 'Google sign-in is not enabled. Please contact support.'
        break
      case 'auth/network-request-failed':
        userFriendlyMessage = 'Network error occurred. Please check your internet connection'
        break
      case 'auth/internal-error':
        userFriendlyMessage = 'An internal error occurred. Please try again'
        break
      default:
        if (error?.message) {
          userFriendlyMessage = `Google login error: ${error.message}`
        }
    }

    const enhancedError = new Error(userFriendlyMessage)
    ;(enhancedError as any).code = errorCode
    ;(enhancedError as any).originalError = error

    throw enhancedError
  }
}

export const getRedirectResult = async () => {
  const result = await auth.getRedirectResult()
  return result && result.user ? result : null
}

export default firebase
